import { Component, Input, OnInit } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { OtherFormularyInformation } from '@cigna/pdl-viewer/drug-search/data-access';
import { exceptionslist } from '@cigna/pdl-viewer/shared/util';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'cigna-notes-definition',
  templateUrl: './notes-definition.component.html',
  styleUrls: ['./notes-definition.component.scss'],
})
export class NotesDefinitionComponent implements OnInit {
  @Input() notesCollection: string[];
  @Input() indicator: string;
  @Input() selectedItemDropDown: string;
  @Input() rsdLimitValue: string;
  @Input() msdLimitValue: string;
  @Input() otherInfo: OtherFormularyInformation;
  @Input() consumerId: string;
  public notesException: string[];
  isNYMessage: boolean;

  constructor(private activRoute: ActivatedRoute) {}

  ngOnInit() {
    const stateselected = this.selectedItemDropDown;
    this.notesException = exceptionslist[stateselected];
    this.isNYMessage =
      (this.activRoute.snapshot.queryParams.pdlYearType === 'NY' &&
        this.notesCollection.indexOf('DS') > -1) ||
      false;
  }
}
